import { css } from '@emotion/react'
import { Button, Cell, Grid, Icon, Tag, Tooltip } from 'bold-ui'
import { FieldStatusEnum, ListFieldStatus } from 'components/form'
import { TextStatus } from 'components/text/TextStatus'
import { getEditableItemRemoveTooltipText } from 'view/atendimentos/atendimento-individual/atendimento-observacao/util-atendObservacao'
import { EditableRow } from 'view/atendimentos/detail/components/EditableList'
import { removeWithOptionalConfirm } from 'view/retificacao-atendimento/removeWithOptionalConfirm'

import { showCodigoProcedimento } from '../../objetivo/resultados-exames/util-resultadosExames'
import { ProcedimentoSigtapFieldModel } from './ProcedimentoSigtapField'

interface ProcedimentoSigtapRowProps {
  model: ProcedimentoSigtapFieldModel
  hideRemoveButton?: boolean
  onRemove?: (itemToRemove: ProcedimentoSigtapFieldModel) => void
  onReset?: (itemToReset: ProcedimentoSigtapFieldModel) => void
  status?: FieldStatusEnum
  controlModifiedStatus?: boolean
}

export function ProcedimentoSigtapRow(props: ProcedimentoSigtapRowProps) {
  const { model, hideRemoveButton = false, onRemove, onReset, status, controlModifiedStatus = false } = props

  const handleRemove = () =>
    removeWithOptionalConfirm({
      shouldAskConfirmation: controlModifiedStatus,
      title: 'Deseja excluir o Procedimento administrativo (SIGTAP)?',
      icon: { name: 'exclamationTriangleOutline', fill: 'alert' },
      onRemove: () => onRemove?.(model),
    })

  const handleReset = () => onReset?.(model)

  const { isEditable, tooltipText } = getEditableItemRemoveTooltipText(model)

  return (
    <EditableRow editing={false}>
      <Grid style={styles.grid} data-testid='ProcedimentoSigtapRow'>
        <Cell size={hideRemoveButton ? 12 : 10} alignSelf='center'>
          <TextStatus status={status}>{`${model.procedimento?.descricao} - ${showCodigoProcedimento(
            model.procedimento?.codigo
          )}`}</TextStatus>
          {model.automatico && <Tag style={styles.tag}>Adicionado automaticamente</Tag>}
        </Cell>

        {!hideRemoveButton && (
          <Cell size={2} style={styles.actions}>
            {controlModifiedStatus ? (
              <ListFieldStatus status={status} onReset={handleReset} onRemove={handleRemove} />
            ) : (
              <Tooltip text={tooltipText}>
                <Button size='small' skin='ghost' onClick={handleRemove} disabled={isEditable}>
                  <Icon icon='trashOutline' />
                </Button>
              </Tooltip>
            )}
          </Cell>
        )}
      </Grid>
    </EditableRow>
  )
}

const styles = {
  grid: css`
    margin: 0;
  `,
  tag: css`
    margin-left: 0.5rem;
  `,
  actions: css`
    align-self: center;
    padding: 0.25rem 0;
    text-align: right;
  `,
}
